/* ==========================================================================
   PDP — galería, selección de variante, stepper y añadir al carrito por AJAX.
   Vanilla, sin dependencias (spec §4).
   ========================================================================== */

(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.gyaaReady === '1') return;
    root.dataset.gyaaReady = '1';

    var variants = [];
    var dataEl = root.querySelector('[data-product-variants]');
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent) || []; } catch (e) { variants = []; }
    }

    var mainImage = root.querySelector('[data-product-main-image]');
    var thumbs = root.querySelectorAll('[data-product-thumb]');
    var idInput = root.querySelector('[data-product-variant-id]');
    var priceEl = root.querySelector('[data-product-price]');
    var addBtn = root.querySelector('[data-product-add]');
    var addLabel = root.querySelector('[data-product-add-label]');
    var form = root.querySelector('[data-product-form]');
    var qtyInput = root.querySelector('[data-qty-input]');

    /* --- Galería: cambiar la imagen principal --------------------------- */
    for (var t = 0; t < thumbs.length; t++) {
      (function (thumb) {
        thumb.addEventListener('click', function () {
          if (mainImage && thumb.dataset.full) mainImage.src = thumb.dataset.full;
          for (var k = 0; k < thumbs.length; k++) {
            thumbs[k].classList.remove('is-active');
            // aria-pressed acompana a is-active: si no se actualiza, el lector de
            // pantalla sigue anunciando como activa la primera miniatura.
            thumbs[k].setAttribute('aria-pressed', 'false');
          }
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-pressed', 'true');
        });
      })(thumbs[t]);
    }

    if (mainImage && root.hasAttribute('data-product-zoom')) initZoom(root, mainImage);

    /* --- Variantes ------------------------------------------------------- */
    function selectedOptions() {
      var values = [];
      var groups = root.querySelectorAll('[data-product-option-index]');
      for (var g = 0; g < groups.length; g++) {
        var checked = groups[g].querySelector('[data-product-option]:checked');
        values.push(checked ? checked.value : null);
      }
      return values;
    }

    function findVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (values[j] !== null && v.options[j] !== values[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    /* Variantes con lo marcado en las opciones de la primera a «hasta» (las de después dan igual). */
    function variantsUpTo(values, hasta) {
      return variants.filter(function (v) {
        for (var j = 0; j <= hasta; j++) if (v.options[j] !== values[j]) return false;
        return true;
      });
    }

    /* Shopify no tiene todas las combinaciones: en las Kwadron Round Liner el #08 solo es de la 3RLLT. Antes se pintaban
       todos los valores de cada opción y, al marcar uno que no existía, al carrito iba la variante de antes (19-oct-2026,
       Gleybert). Ahora la primera opción enseña todos sus valores y cada una de las siguientes solo los que existen con lo
       marcado en las de antes. Y en toda la tienda solo se puede marcar lo que tiene stock (Robert, 19-oct: «de lo
       contrario no se deben poder escoger»): lo agotado sale tachado y desactivado. */
    function paintOptions() {
      var values = selectedOptions();
      var groups = root.querySelectorAll('[data-product-option-index]');
      for (var g = 0; g < groups.length; g++) {
        var before = g ? variantsUpTo(values, g - 1) : variants;
        var inputs = groups[g].querySelectorAll('[data-product-option]');
        for (var i = 0; i < inputs.length; i++) {
          var withValue = before.filter(function (v) { return v.options[g] === inputs[i].value; });
          var inStock = withValue.some(function (v) { return v.available; });
          var label = inputs[i].labels[0];
          inputs[i].hidden = !withValue.length;
          inputs[i].disabled = !inStock;
          if (label) {
            label.hidden = !withValue.length;
            label.classList.toggle('is-unavailable', withValue.length > 0 && !inStock);
          }
        }
      }
    }

    /* Al cambiar la opción «k», si lo marcado no existe o está agotado, pasa a una variante con stock con las opciones
       hasta «k», la que conserve más de lo marcado después (por orden). */
    function fixSelection(k) {
      var values = selectedOptions();
      var current = findVariant(values);
      if (current && current.available) return;
      var candidates = variantsUpTo(values, k);
      var inStock = candidates.filter(function (v) { return v.available; });
      if (inStock.length) candidates = inStock;
      for (var j = k + 1; j < values.length && candidates.length > 1; j++) {
        var same = candidates.filter(function (v) { return v.options[j] === values[j]; });
        if (same.length) candidates = same;
      }
      var best = candidates[0];
      if (!best) return;
      var groups = root.querySelectorAll('[data-product-option-index]');
      for (var g = k + 1; g < groups.length; g++) {
        var inputs = groups[g].querySelectorAll('[data-product-option]');
        for (var i = 0; i < inputs.length; i++) if (inputs[i].value === best.options[g]) inputs[i].checked = true;
      }
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function updateVariant() {
      var variant = findVariant(selectedOptions());
      paintOptions();
      if (!variant) {
        // Sin variante no se compra nada (antes se quedaba la de antes en el carrito).
        if (addBtn) addBtn.disabled = true;
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);

      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addLabel) {
          // Los dos textos (traducidos) los pinta la sección en data-*. Antes, al volver a una variante con
          // stock se reusaba el texto del momento, y tras pasar por una agotada se quedaba en «Sold out».
          addLabel.textContent = variant.available
            ? addLabel.dataset.available || 'Add to cart'
            : addLabel.dataset.soldOut || 'Sold out';
        }
      }

      // Actualiza la URL sin recargar, para que compartir el enlace lleve a la variante
      if (window.history.replaceState && root.dataset.productUrl) {
        window.history.replaceState({}, '', root.dataset.productUrl + '?variant=' + variant.id);
      }

      // Si la variante tiene imagen propia, saltar a ella
      if (variant.featured_image && mainImage) {
        mainImage.src = variant.featured_image.src;
      }
    }

    var optionInputs = root.querySelectorAll('[data-product-option]');
    for (var o = 0; o < optionInputs.length; o++) {
      optionInputs[o].addEventListener('change', function (e) {
        fixSelection(parseInt(e.target.closest('[data-product-option-index]').getAttribute('data-product-option-index'), 10));
        updateVariant();
      });
    }
    paintOptions();

    /* --- Stepper de cantidad -------------------------------------------- */
    function step(delta) {
      if (!qtyInput) return;
      var next = (parseInt(qtyInput.value, 10) || 1) + delta;
      qtyInput.value = next < 1 ? 1 : next;
    }

    var down = root.querySelector('[data-qty-down]');
    var up = root.querySelector('[data-qty-up]');
    if (down) down.addEventListener('click', function () { step(-1); });
    if (up) up.addEventListener('click', function () { step(1); });

    /* --- Añadir al carrito por AJAX ------------------------------------- */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!addBtn || addBtn.disabled) return;

        var previous = addLabel ? addLabel.textContent : '';
        addBtn.disabled = true;

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: idInput ? idInput.value : null,
            quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1
          })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (window.GYAA && window.GYAA.refreshCartCount) window.GYAA.refreshCartCount();
            if (window.GYAA && window.GYAA.vueloAlCarrito) window.GYAA.vueloAlCarrito(addBtn);
            /* El "✓" del boton es la unica senal visual; un lector de pantalla no
               lo anuncia, asi que la confirmacion va por la region aria-live. */
            if (window.GYAA && window.GYAA.announce) {
              window.GYAA.announce(addBtn.getAttribute('data-added-label') || '');
            }
            if (addLabel) addLabel.textContent = '✓';
            setTimeout(function () {
              if (addLabel) addLabel.textContent = previous;
              addBtn.disabled = false;
            }, 1200);
          })
          .catch(function () {
            /* Antes el fallo se tragaba en silencio: el boton se reactivaba y ya.
               Nadie se enteraba de que no se habia anadido nada. */
            if (window.GYAA && window.GYAA.announce) {
              window.GYAA.announce(addBtn.getAttribute('data-error-label') || '');
            }
            if (addLabel) addLabel.textContent = previous;
            addBtn.disabled = false;
          });
      });
    }

    /* --- Wishlist: localStorage (fallback del spec §6, Task 11) ---------- */
    var wishBtn = root.querySelector('[data-product-wishlist]');
    if (wishBtn) {
      var handle = (root.dataset.productUrl || '').split('/').pop();
      var KEY = 'gyaa:wishlist';

      function read() {
        try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
      }

      function paint() {
        wishBtn.classList.toggle('is-saved', read().indexOf(handle) !== -1);
      }

      wishBtn.addEventListener('click', function () {
        var list = read();
        var i = list.indexOf(handle);
        if (i === -1) list.push(handle); else list.splice(i, 1);
        localStorage.setItem(KEY, JSON.stringify(list));
        paint();
      });

      paint();
    }
  }

  /* --- Zoom en la foto (Robert, 20-oct-2026) --------------------------------
     Elegido en el prototipo docs/prototipos/2026-10-20-zoom-producto: con ratón, una lupa que sigue al cursor (A);
     con el dedo quieto en la foto se abre debajo una ventana con lo que hay en el recuadro, ampliado (C). Arrastrar
     lo recorre y al soltar se va; si el dedo se mueve antes, la página baja como siempre. El aumento es el que da la
     foto, entre 2 y 2,5, y si ya se ve a su tamaño real no hay zoom: ampliarla solo la emborrona (39 productos en PC,
     4 en el celular). La foto a 2400 px solo se baja al usarlo. En el celular, un aviso dice cómo hasta la primera vez
     que se usa. Lo enciende el interruptor «Zoom en la foto» de la sección: data-product-zoom trae el texto del aviso. */
  var ZOOM_MIN = 2;
  var ZOOM_MAX = 2.5;
  var ZOOM_SIN = 1.15;       // píxeles de la foto por píxel de pantalla: por debajo, no se amplía
  var ZOOM_ANCHO = 2400;     // el CDN de Shopify no agranda: si la original es menor, da la original
  var ZOOM_PULSACION = 260;  // ms con el dedo quieto
  var ZOOM_HOLGURA = 10;     // px que se puede mover el dedo mientras tanto: más es que quiere bajar la página
  var ZOOM_USADO = 'gyaa:zoom-usado';
  var ZOOM_ICONO = '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="7" cy="7" r="5"/><path d="M11 11l3.5 3.5M7 4.8v4.4M4.8 7h4.4"/></svg>';

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  function initZoom(root, img) {
    var box = img.parentNode;
    var hintText = root.getAttribute('data-product-zoom');
    var z = ZOOM_MIN;
    var mouse = null;   // dónde está el ratón mientras pasa por la foto
    var press = null;   // el dedo en la foto: { x, y, scroll, timer, on }
    var queued = 0;
    var hint = null;

    function part(cls, parent) {
      var el = document.createElement('div');
      el.className = cls;
      el.setAttribute('aria-hidden', 'true');
      parent.appendChild(el);
      return el;
    }

    var lens = part('gyaa-product__lens', box);
    var frame = part('gyaa-product__zoom-frame', box);
    var win = part('gyaa-product__zoom-window', root);

    /* Dónde cae la foto en su caja (object-fit: contain) y cuántos píxeles suyos hay por píxel de pantalla. Con la de
       1640 que se ve, si la original es mayor el número sale por lo bajo, pero entonces pasa de 2 igual. */
    function geo() {
      var r = img.getBoundingClientRect();
      var k = Math.min(r.width / img.naturalWidth, r.height / img.naturalHeight);
      var w = img.naturalWidth * k, h = img.naturalHeight * k;
      return { left: r.left, top: r.top, width: r.width, height: r.height, x: (r.width - w) / 2, y: (r.height - h) / 2, w: w, h: h, real: img.naturalWidth / w };
    }

    function zoomable() {
      return img.complete && img.naturalWidth > 0 && geo().real >= ZOOM_SIN;
    }

    /* La de 2400 encima de la que ya se ve: mientras llega, se ve la de debajo. */
    function backgrounds() {
      var src = img.currentSrc || img.src;
      var big = new URL(src, location.href);
      big.searchParams.set('width', ZOOM_ANCHO);
      return 'url("' + big.href + '"), url("' + src + '")';
    }

    function later() {
      if (!queued) queued = requestAnimationFrame(function () { queued = 0; lensMove(); winMove(); });
    }

    /* --- Con ratón: la lupa ---------------------------------------------- */
    function lensMove() {
      if (!mouse || !lens.classList.contains('is-on')) return;
      var g = geo();
      var x = mouse.x - g.left, y = mouse.y - g.top;
      var half = lens.offsetWidth / 2;
      lens.style.translate = (x - half) + 'px ' + (y - half) + 'px';
      lens.style.backgroundSize = g.w * z + 'px ' + g.h * z + 'px';
      lens.style.backgroundPosition = (half - (x - g.x) * z) + 'px ' + (half - (y - g.y) * z) + 'px';
    }

    function lensOn() {
      if (lens.classList.contains('is-on') || !zoomable()) return;
      z = clamp(geo().real, ZOOM_MIN, ZOOM_MAX);
      lens.style.backgroundImage = backgrounds();
      lens.classList.add('is-on');
      box.classList.add('is-zooming');
      lensMove();
      // La galería se queda fija al bajar la página: la foto se mueve bajo el ratón quieto.
      window.addEventListener('scroll', later, { passive: true });
    }

    function lensOff() {
      lens.classList.remove('is-on');
      box.classList.remove('is-zooming');
      window.removeEventListener('scroll', later);
    }

    box.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      mouse = { x: e.clientX, y: e.clientY };
      lensOn();
      later();
    });
    box.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch') return;
      mouse = null;
      lensOff();
    });

    /* --- Con el dedo: la ventana ----------------------------------------- */
    function winMove() {
      if (!press || !press.on) return;
      var g = geo();
      var x = clamp(press.x - g.left, 0, g.width), y = clamp(press.y - g.top, 0, g.height);
      var vw = win.clientWidth, vh = win.clientHeight;
      var fw = Math.min(g.w, vw / z), fh = Math.min(g.h, vh / z);
      var fx = clamp(x - g.x - fw / 2, 0, g.w - fw), fy = clamp(y - g.y - fh / 2, 0, g.h - fh);
      frame.style.width = fw + 'px';
      frame.style.height = fh + 'px';
      frame.style.translate = (g.x + fx) + 'px ' + (g.y + fy) + 'px';
      win.style.backgroundSize = g.w * z + 'px ' + g.h * z + 'px';
      win.style.backgroundPosition = ((vw - fw * z) / 2 - fx * z) + 'px ' + ((vh - fh * z) / 2 - fy * z) + 'px';
    }

    /* Debajo de la foto y del mismo tamaño; si no cabe, al lado (la tableta en horizontal); y si tampoco, en el lado
       con más sitio, más baja. */
    function winOn() {
      if (!press || !zoomable() || window.scrollY !== press.scroll) return;
      var r = box.getBoundingClientRect();
      var gap = 10, edge = 8, H = window.innerHeight;
      var below = H - r.bottom - gap - edge, above = r.top - gap - edge;
      var left = r.left, top = r.bottom + gap, h = r.height;
      if (below < h) {
        if (window.innerWidth - r.right - gap - edge >= r.width) {
          left = r.right + gap;
          top = r.top;
        } else {
          h = Math.min(r.height, Math.max(below, above, r.height / 2));
          if (above > below) top = r.top - gap - h;
        }
      }
      z = clamp(geo().real, ZOOM_MIN, ZOOM_MAX);
      win.style.left = left + 'px';
      win.style.top = clamp(top, edge, H - h - edge) + 'px';
      win.style.width = r.width + 'px';
      win.style.height = h + 'px';
      win.style.backgroundImage = backgrounds();
      press.on = true;
      win.classList.add('is-on');
      frame.classList.add('is-on');
      winMove();
      hintDone();
      if (navigator.vibrate && (!navigator.userActivation || navigator.userActivation.hasBeenActive)) navigator.vibrate(8);
    }

    function winOff() {
      if (!press) return;
      clearTimeout(press.timer);
      win.classList.remove('is-on');
      frame.classList.remove('is-on');
      press = null;
    }

    box.addEventListener('touchstart', function (e) {
      winOff();
      if (e.touches.length !== 1 || !zoomable()) return;   // con dos dedos, el pellizco es de la página
      press = { x: e.touches[0].clientX, y: e.touches[0].clientY, scroll: window.scrollY, on: false };
      press.timer = setTimeout(winOn, ZOOM_PULSACION);
    }, { passive: true });

    box.addEventListener('touchmove', function (e) {
      if (!press) return;
      var t = e.touches[0];
      // Otro dedo, o la página ya se está moviendo y no se puede parar: fuera.
      if (e.touches.length !== 1 || (press.on && !e.cancelable)) return winOff();
      if (press.on) {
        e.preventDefault();   // mientras se recorre la foto, la página no se mueve
        press.x = t.clientX;
        press.y = t.clientY;
        later();
      } else if (Math.abs(t.clientX - press.x) > ZOOM_HOLGURA || Math.abs(t.clientY - press.y) > ZOOM_HOLGURA) {
        winOff();
      }
    }, { passive: false });

    box.addEventListener('touchend', function (e) { if (!e.touches.length) winOff(); });
    box.addEventListener('touchcancel', winOff);
    // Sin el menú de «guardar imagen» ni arrastrar la foto mientras se mantiene el dedo.
    box.addEventListener('contextmenu', function (e) { if (press) e.preventDefault(); });
    box.addEventListener('dragstart', function (e) { if (press) e.preventDefault(); });

    /* --- El aviso del celular -------------------------------------------- */
    function hintDone() {
      try { localStorage.setItem(ZOOM_USADO, '1'); } catch (e) {}
      if (hint) hint.remove();
      hint = null;
    }

    var used = false;
    try { used = localStorage.getItem(ZOOM_USADO) === '1'; } catch (e) {}
    if (hintText && !used && window.matchMedia('(hover: none) and (pointer: coarse)').matches) {
      hint = document.createElement('div');
      hint.className = 'gyaa-product__zoom-hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.innerHTML = ZOOM_ICONO;
      hint.appendChild(document.createTextNode(hintText));
      box.appendChild(hint);
    }

    /* Cada foto que se pone (miniaturas, variantes) decide si hay zoom. */
    function onPhoto() {
      var ok = zoomable();
      box.classList.toggle('has-zoom', ok);
      if (hint) hint.hidden = !ok;
      if (lens.classList.contains('is-on')) {
        lensOff();
        if (mouse) lensOn();
      }
    }
    img.addEventListener('load', onPhoto);
    onPhoto();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-product-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
